import React, { useState } from "react";
// import { useHistory } from "react-router-dom";
import {
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  Box,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import { dataProvider } from "../util";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
import Swal from "sweetalert2";

var moment = require("moment");
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 10,
    paddingTop: 60,
  },
  formRoot: {
    "& > *": {
      //   margin: theme.spacing(1),
      //   minWidth: '100%',
      //   background: 'red'
    },
  },
  flow: {
    width: "100%",
  },
  icon: {
    color: "red",
  },
  section1: {
    marginTop: 20,
  },
  subTitle: {
    color: "#0635C9",
    textAlign: "left",
    fontSize: "1.2em",
  },
}));

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

export default function Report() {
  const classes = useStyles();
  const [titleData, setTitleData] = useState("");
  const [salesTitleData, setSalesTitleData] = useState("");
  const [transactionTitleData, setTransactionTitleData] = useState("");
  const [fdata, setData] = useState({});
  const [reportData, setReportData] = useState({});
  const [productData, setProductData] = useState([]);
  const [transactionData, setTransactionData] = useState({});

  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  const rows = [
    createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
    createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
    createData("Eclair", 262, 16.0, 24, 6.0),
    createData("Cupcake", 305, 3.7, 67, 4.3),
    createData("Gingerbread", 356, 16.0, 49, 3.9),
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Sales Report" + titleData,
      },
    },
  }; 
  
  const sales_options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Daily Sales Report" + salesTitleData,
      },
    },
  };

  // New transaction breakdown chart options
  const transaction_pie_options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
        text: "Transaction Breakdown by Payment Method" + transactionTitleData,
      },
    },
  };

  const chart_data = {
    labels: reportData?.invoice?.map((i) => i.dt.substring(0, 10)),
    datasets: [
      {
        label: "Labour",
        data: reportData?.invoice?.map((i) => i.labour),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Products",
        data: reportData?.invoice?.map((i) => i.products),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Discounts",
        data: reportData?.invoice?.map((i) => i.discounts),
        backgroundColor: "rgb(129, 93, 163)",
      },
    ],
  };
  
  const sales_chart_data = {
    labels: reportData?.sales?.map((i) => i.dt.substring(0, 10)),
    datasets: [
      {
        label: "Sales",
        data: reportData?.sales?.map((i) => i.sales),
        backgroundColor: "#50EC1F",
      }
    ],
  };

  // New transaction breakdown chart data
  const getTransactionPieData = () => {
    if (!transactionData?.method_summary) return { labels: [], datasets: [] };
    
    const methods = transactionData.method_summary.map(item => 
      item.method === 'credit-card' ? 'Credit Card' :
      item.method === 'debit-card' ? 'Debit Card' :
      item.method === 'cash' ? 'Cash' :
      item.method === 'online' ? 'Online' :
      item.method || 'Unknown'
    );
    
    const amounts = transactionData.method_summary.map(item => parseFloat(item.total_amount));
    
    const colors = [
      '#FF6384',
      '#36A2EB', 
      '#FFCE56',
      '#4BC0C0',
      '#9966FF',
      '#FF9F40'
    ];

    return {
      labels: methods,
      datasets: [
        {
          data: amounts,
          backgroundColor: colors.slice(0, methods.length),
          borderColor: colors.slice(0, methods.length),
          borderWidth: 1,
        },
      ],
    };
  };

  const formChange = (e) => {
    setData({
      ...fdata,
      [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
    });
  };

  const report = async (e) => {
    if (!fdata.start_date) {
      return Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Select start date",
        showConfirmButton: false,
        timer: 1500,
      });
    }
    if (!fdata.end_date) {
      return Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Select end date",
        showConfirmButton: false,
        timer: 1500,
      });
    }

    if (moment(fdata.end_date).diff(moment(fdata.start_date), "days") > 365) {
      return Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Do reports within 365 days",
        showConfirmButton: false,
        timer: 1500,
      });
    }

    try {
      const mydata = await dataProvider("post", "/report", fdata);
      const products_data = await dataProvider(
        "post",
        "/report-products",
        fdata
      );
      // New transaction breakdown API call
      const transaction_breakdown = await dataProvider(
        "post", 
        "/report-transactions", 
        fdata
      );

      const pdata = products_data.data;

      let arr = [];
      let sum = 0;
      pdata.forEach((p) => {
        let prod = JSON.parse(p.products);
        if (prod.length > 0) {
          prod.forEach((invoice_product) => {
            sum = parseFloat(invoice_product.price) * parseInt(invoice_product.qty) + sum;
            console.log(invoice_product.qty, invoice_product.title);
            console.log(invoice_product, "product");
            let index = arr.findIndex((x) => x.title === invoice_product.title && x.description === invoice_product.description  );
            if (index > -1) {
              let ptotal = (parseFloat(invoice_product.price) * parseInt(invoice_product.qty)) + arr[index].total
              
              arr[index] = {
                title: invoice_product.title,
                description: invoice_product.description,
                qty: parseInt(invoice_product.qty) + arr[index].qty,
                total: ptotal,
              };
            } else {
              let ptotal = parseFloat(invoice_product.price) * parseInt(invoice_product.qty);
              arr.push({
                title: invoice_product.title,
                description: invoice_product.description,
                qty: parseInt(invoice_product.qty),
                total: ptotal,
              });
            }
          });
        }
      });

      arr.sort((a, b) => (a.qty < b.qty) ? 1 : -1)
      setProductData(arr);
      
      var p = 0;
      var l = 0;
      var d = 0;
      mydata.data.invoice.map((i) => {
        p += i.products;
        l += i.labour;
        d += i.discounts;
      });
      setTitleData(
        ` - Labour: ${l?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })} Products: ${p?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}  Discounts: ${d?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}`
      );

      var tot_sales = 0;
      mydata.data.sales.map((i) => {
        tot_sales += i.sales;
      });
      setSalesTitleData(
        ` - Total Sales: ${tot_sales?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}`
      );

      // Set transaction breakdown data
      setTransactionData(transaction_breakdown.data);
      
      // Calculate transaction totals for title
      var total_transactions = 0;
      var total_count = 0;
      if (transaction_breakdown.data.method_summary) {
        transaction_breakdown.data.method_summary.forEach((item) => {
          total_transactions += parseFloat(item.total_amount);
          total_count += parseInt(item.total_count);
        });
      }
      
      setTransactionTitleData(
        ` - Total: ${total_transactions?.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })} (${total_count} transactions)`
      );

      setReportData(mydata.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2} style={{ flexGrow: 1 }}>
        <Grid item xs={12}>
          <Typography gutterBottom variant="h2" style={{ fontSize: "2em" }}>
            Reports
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="start_date"
            name="start_date"
            label="Start"
            type="date"
            onChange={formChange}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>{" "}
        <Grid item xs={6}>
          <TextField
            id="end_date"
            name="end_date"
            label="End"
            type="date"
            onChange={formChange}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            name="sales"
            variant="contained"
            value="sales"
            color="primary"
            onClick={() => report("sales")}
          >
            Sales Report
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Bar options={options} data={chart_data} />
        </Grid>
        <Grid item xs={12}>
          <Bar options={sales_options} data={sales_chart_data} />
        </Grid>
        
        {/* New Transaction Breakdown Section */}
        <Grid item xs={12} style={{ marginTop: "2em" }}>
          <Typography gutterBottom variant="h5">
            Transaction Breakdown by Payment Method
            {fdata.start_date ? ` (${fdata.start_date} to ${fdata.end_date})` : ""}
          </Typography>
        </Grid>
        
        {/* Transaction Breakdown Chart */}
        <Grid item xs={12} md={6}>
          <Box display="flex" justifyContent="center" alignItems="center" style={{ height: '400px', padding: '20px' }}>
            <div style={{ width: '100%', maxWidth: '350px', height: '350px' }}>
              <Doughnut options={transaction_pie_options} data={getTransactionPieData()} />
            </div>
          </Box>
        </Grid>
        
        {/* Transaction Breakdown Table */}
        <Grid item xs={12} md={6}>
          <Box style={{ padding: '20px' }}>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="transaction breakdown table">
                <TableHead>
                  <TableRow>
                    <TableCell><b>Payment Method</b></TableCell>
                    <TableCell align="right"><b>Count</b></TableCell>
                    <TableCell align="right"><b>Total Amount</b></TableCell>
                    <TableCell align="right"><b>Percentage</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactionData?.method_summary?.map((row) => {
                    const total_all = transactionData.method_summary.reduce((sum, item) => sum + parseFloat(item.total_amount), 0);
                    const percentage = total_all > 0 ? ((parseFloat(row.total_amount) / total_all) * 100).toFixed(1) : 0;
                    const methodName = 
                      row.method === 'credit-card' ? 'Credit Card' :
                      row.method === 'debit-card' ? 'Debit Card' :
                      row.method === 'cash' ? 'Cash' :
                      row.method === 'online' ? 'Online' :
                      row.method || 'Unknown';
                      
                    return (
                      <TableRow key={row.method}>
                        <TableCell component="th" scope="row">
                          {methodName}
                        </TableCell>
                        <TableCell align="right">{row.total_count}</TableCell>
                        <TableCell align="right">
                          {parseFloat(row.total_amount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </TableCell>
                        <TableCell align="right">{percentage}%</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>

        <Grid item xs={12} style={{ marginTop: "2em" }}>
          <Typography gutterBottom variant="h5" style={{}}>
            Inventory Depletion{" "}
            {fdata.start_date
              ? ` for ${fdata.start_date} to ${fdata.end_date}`
              : ""}
          </Typography>

          <Box display="flex" justifyContent="center" alignItems="center">
            <Grid xs={12} md={10}>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Title</b>
                      </TableCell>
                      <TableCell>
                        <b>Description</b>
                      </TableCell>
                      <TableCell align="right">
                        <b>Qty</b>
                      </TableCell>
                      <TableCell align="right">
                        <b>Total</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productData.map((row) => (
                      <TableRow key={row.title+row.description}>
                        <TableCell component="th" scope="row">
                          {row.title}
                        </TableCell>
                        <TableCell align="right">{row.description}</TableCell>
                        <TableCell align="right">{row.qty}</TableCell>
                        <TableCell align="right">{row.total.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}